/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/scholarship-tab` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de bolsas vinculadas à matrícula com tipo, status e desconto, para exibição na aba Detalhe de Bolsa do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados de bolsa de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/scholarship-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
